<div class="park-card-container">
    <!-- Park Hours: Operating, Park Hopper, and Extended Evening -->
    <finder-park-section
        class="park-hours"
        [groups]="parkHours"
        [permanentSchedule]="permanentSchedule"
        [parkHours]="true"
        [blockouts]="location.blockouts"
        [location]="location"
        [icon]="icon"
        type="operating"
        [title]="location.title"
        [labels]="labels">
    </finder-park-section>
    <div class="schedules"
        [ngClass]="{'change-direction': changeDirection, 'empty-schedules': !sections.length}">
        <h3 class="text">{{labels.schedules}}</h3>
        <ng-container *ngIf="isDesktop">
            <!-- Events -->
            <finder-park-section
                *ngIf="events"
                class="events"
                [ngClass]="{'single': sections.length === 1}"
                [groups]="events.data"
                [title]="events.title"
                [location]="location"
                [type]="events.type"
                [labels]="labels">
            </finder-park-section>
            <div class="entertainment" *ngIf="sections.length">
                <ng-container *ngFor="let section of sections | slice: 1">
                    <finder-park-section
                        class="{{section.style}}"
                        [groups]="section.data"
                        [title]="section.data?.title"
                        [location]="location"
                        [type]="section.type"
                        [labels]="labels">
                    </finder-park-section>
                </ng-container>
            </div>
        </ng-container>
        <!-- For mobile view, we wrap the park-sections into collapasible sections -->
        <div class="sections"
            *ngIf="!isDesktop"
            [ngClass]="{'single': sections.length === 1 && !location.closedFacilities}">
            <ng-container *ngFor="let section of sections">
                <finder-section
                    [id]="section.id"
                    [labels]="section.labels"
                    [locationTitle]="location.title"
                    [disableDeepLink]="true"
                    [expanded]="false">
                    <finder-park-section
                        [groups]="section.data"
                        [location]="location"
                        [type]="section.type"
                        [labels]="labels">
                        <div class="blockout"
                            *ngFor="let blockout of location.blockouts"
                            [ngClass]="{'single': location.blockouts?.length === 1}">
                            <span class="name">{{blockout.name}}</span>
                        </div>
                        <ng-container *ngIf="!location.blockouts?.length">
                            <span class="subtitle">{{emptyHoursText}}</span>
                            <finder-disclaimer [disclaimer]="labels.emptyHours?.disclaimer"></finder-disclaimer>
                        </ng-container>
                    </finder-park-section>
                </finder-section>
            </ng-container>
        </div>
    </div>
    <div class="closed-facilities" *ngIf="closedFacilities">
        <finder-section
            id="{{location.urlFriendlyId}}-closed-facilities"
            [labels]="{ sectionTitle: labels.closedForRefurbishment }"
            [locationTitle]="location.title"
            [disableDeepLink]="true"
            [expanded]="isClosedFacilitiesExpanded">
            <ng-container *ngFor="let facility of closedFacilities">
                <div class="facility"
                    [ngClass]="{'single': closedFacilities.length === 1}">
                    <span class="name">{{facility.name}}</span>
                    <span>{{labels.temporaryUnavailable}}</span>
                </div>
            </ng-container>
        </finder-section>
    </div>
    <div class="loading-layer" *ngIf="loading">
        <finder-loading-spinner></finder-loading-spinner>
    </div>
</div>
